import * as React from 'react';
import { SVGProps } from 'react';

const IconMapStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 1.131v10.404l-3.852 2.568-6-2L1 14.868V4.465l3.852-2.568 6 2L15 1.13Zm-5 4.59L6 4.387v5.892l4 1.334V5.72Zm2 5.41 1-.666V4.869l-1 .666v5.597Zm-8-.666V4.869l-1 .666v5.597l1-.667Z"
    />
  </svg>
);
export default IconMapStrokedSizeS;
